<script setup lang="ts">
    import { ref, toRef } from 'vue'
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import ChartBox from '@/js/components/Chart/ChartBox.vue'
    import { useSemester } from '@/js/composables/useSemester'
    import type { Kennzahl, DashboardValue } from '@/js/composables/chart/types'

    const props = defineProps<{
        dashboardData: DashboardValue[]
        yearsToDisplay: number
    }>()

    const { dashboardDataYears } = useSemester(toRef(props, 'dashboardData'), toRef(props, 'yearsToDisplay'))

    const kennzahlen = ref<Kennzahl[]>([
        {
            kennzahlId: '1.1.',
            kennzahlTitle: 'Anzahl Bewerber*innen',
            types: ['BarChartStacked', 'LineChart'],
            dataStrategy: 'stacked',
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl der Bewerber*innen',
            targetValue: '7,5',
            showTargetValue: props.dashboardData.length > 0,
            datasetLabels: ['Immaquote', 'internationale Bewerber*innen', 'deutsche Bewerber*innen']
        },
        {
            kennzahlId: '1.2.',
            kennzahlTitle: 'Anzahl der Einschreibungen und Zulassungen',
            types: ['BarChartStacked', 'LineChart'],
            dataStrategy: 'mixedAxis',
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl der Einschreibungen',
            yAxesLabelStringTwo: 'Anzahl der Zulassungen',
            showTargetValue: false,
            datasetLabels: ['Immaquote', 'Einschreibungen', 'Zulassungen']
        },
        {
            kennzahlId: '1.3.',
            kennzahlTitle: 'Anzahl der Studienanfänger pro Studienjahr',
            types: ['BarChart', 'LineChart'],
            dataStrategy: 'yearlyAggregate',
            xAxesLabelString: 'Studienjahr',
            yAxesLabelString: 'Anzahl der Studienanfänger',
            showTargetValue: false
        }
    ])
</script>

<template>
    <ContentCollapse collapse-key="collapse-dashboard-ziel-1" title="1. Bewerbungsstatistik" is-visible-by-default>
        <div class="d-flex flex-wrap p-4 justify-space-between ga-1">
            <ChartBox
                v-for="(kennzahl, key) in kennzahlen"
                :key="kennzahl.kennzahlId"
                :kennzahl="kennzahl"
                :dashboard-data="dashboardData"
                :dashboard-data-years="dashboardDataYears"
                storage-key=""
                :box-size="350"
                :show-title="true"
                :show-target-value="false"
                :center-box="kennzahlen.length === 2 && key === 1"
            />
        </div>
    </ContentCollapse>
</template>

<style scoped></style>
